// Links to Ownezzy's own site (the platform that hosts every store). On a local machine the marketing
// site runs at localhost:3000, so local stores link there instead of the live ownezzy.com.
const host = window.location.hostname;
const isLocal = host === "localhost" || host === "127.0.0.1" || host.endsWith(".localhost");

export const OWNEZZY_URL = isLocal ? "http://localhost:3000" : "https://ownezzy.com";
export const OWNEZZY_TERMS_URL = `${OWNEZZY_URL}/terms`;
export const OWNEZZY_PRIVACY_URL = `${OWNEZZY_URL}/privacy`;
export const OWNEZZY_PLANS_URL = `${OWNEZZY_URL}/#plans`;
export const OWNEZZY_DEMOS_URL = `${OWNEZZY_URL}/#select-website`;

// The Offers section is not a real category; this value stands for it wherever a category name is expected
export const OFFERS = "__offers";
